// The require scope
var __webpack_require__ = {};

// webpack/runtime/define_property_getters
(() => {
__webpack_require__.d = (exports, definition) => {
	for(var key in definition) {
        if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
        }
    }
};
})();
// webpack/runtime/has_own_property
(() => {
__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
})();
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  mI: () => (/* reexport */ FuncionalidadesMap),
  Ud: () => (/* reexport */ security_Permissao),
  l6: () => (/* reexport */ Rbac),
  b5: () => (/* reexport */ security_TipoVinculo),
  pJ: () => (/* reexport */ TIPOS_COMANDO_INSTITUICAO),
  bI: () => (/* reexport */ decomporUrlAcesso),
  DL: () => (/* reexport */ FuncionalidadesMap_Funcionalidade),
  Ru: () => (/* reexport */ security_TipoUsuario),
  Xk: () => (/* reexport */ composicaoUrlAcesso),
  $e: () => (/* reexport */ ehTipoComandoInstituicao)
});

;// CONCATENATED MODULE: ./src/security/Permissao.ts
const Permissao = {
    // Módulo
    GESTAOPACS: 'GESTAOPACS_GESTAOPACS',
    // Páginas
    ALERTAS: 'GESTAOPACS_ALERTAS',
    NOTIFICACOES_EXAMES: 'GESTAOPACS_IEXAMES',
    RECUPERACAO_EXAMES: 'GESTAOPACS_RECUPERACAOEXAMES',
    PACS_EXAMES: 'GESTAOPACS_PACSEXAMES',
    DICOM_HUB: 'GESTAOPACS_DICOMHUB',
    SERVIDOR_PACS: 'GESTAOPACS_SERVIDORPACS',
    MINIPACS: 'GESTAOPACS_MINIPACS',
    PAGINA_VISUALIZADOR: 'GESTAOPACS_PAGINAVISUALIZADOR',
    // Namespace do Visualizador instalado na ponta (rotas /dicom-hub-app/*)
    DICOM_HUB_APP: 'GESTAOPACS_DICOMHUBAPP'
};
/* export default */ const security_Permissao = (Permissao);

;// CONCATENATED MODULE: ./src/security/TipoVinculo.ts
var TipoVinculo_TipoVinculo = /*#__PURE__*/ function(TipoVinculo) {
    TipoVinculo["ADMIN"] = "G";
    TipoVinculo["MUNICIPIO"] = "M";
    TipoVinculo["ESTADO"] = "E";
    TipoVinculo["REDE_TELECONSULTORIA"] = "D";
    TipoVinculo["REDE_TELEMEDICINA"] = "R";
    TipoVinculo["INSTITUICAO"] = "I";
    TipoVinculo["USUARIO"] = "U";
    return TipoVinculo;
}(TipoVinculo_TipoVinculo || {});
/* export default */ const security_TipoVinculo = (TipoVinculo_TipoVinculo);

;// CONCATENATED MODULE: ./src/security/FuncionalidadesMap.ts


var FuncionalidadesMap_Funcionalidade = /*#__PURE__*/ function(Funcionalidade) {
    // Acesso ao módulo gestão PACS
    Funcionalidade["MODULO"] = "MODULO";
    // Acesso as páginas do módulo gestão PACS
    Funcionalidade["PAGINA_NOTIFICACAO"] = "PAGINA_NOTIFICACAO";
    Funcionalidade["PAGINA_AUTOMACAO"] = "PAGINA_AUTOMACAO";
    Funcionalidade["PAGINA_PACS"] = "PAGINA_PACS";
    Funcionalidade["PAGINA_PACS_GERENCIAR"] = "PAGINA_PACS_GERENCIAR";
    Funcionalidade["PAGINA_ALERTAS"] = "PAGINA_ALERTAS";
    Funcionalidade["PAGINA_DICOM_HUB"] = "PAGINA_DICOM_HUB";
    Funcionalidade["PAGINA_SERVIDOR_PACS"] = "PAGINA_SERVIDOR_PACS";
    Funcionalidade["PAGINA_VISUALIZADOR"] = "PAGINA_VISUALIZADOR";
    // Acesso às abas da página de notificações
    Funcionalidade["ABA_ATIVIDADES"] = "ABA_ATIVIDADES";
    // Operar um minipacs pelo aplicativo (rotas /minipacs/*)
    Funcionalidade["MINIPACS"] = "MINIPACS";
    // Operar o Visualizador instalado na ponta (rotas /dicom-hub-app/*)
    Funcionalidade["DICOM_HUB_APP"] = "DICOM_HUB_APP";
    return Funcionalidade;
}(FuncionalidadesMap_Funcionalidade || {});
const FuncionalidadesMap = {
    ["MODULO"]: {
        descricao: 'Acesso ao módulo gestão PACS.',
        permissoes: [
            security_Permissao.GESTAOPACS
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["PAGINA_ALERTAS"]: {
        descricao: 'Acesso a página de alertas do módulo gestão PACS.',
        permissoes: [
            security_Permissao.ALERTAS
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["ABA_ATIVIDADES"]: {
        descricao: 'Acesso à aba Atividades da página de notificações.',
        permissoes: [
            security_Permissao.ALERTAS
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["PAGINA_NOTIFICACAO"]: {
        descricao: 'Acesso a página das notificações de integrações com o STT.',
        permissoes: [
            security_Permissao.NOTIFICACOES_EXAMES
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["PAGINA_AUTOMACAO"]: {
        descricao: 'Acesso a página automação.',
        permissoes: [
            security_Permissao.RECUPERACAO_EXAMES
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["PAGINA_PACS"]: {
        descricao: 'Acesso a página PACS.',
        permissoes: [
            security_Permissao.PACS_EXAMES
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["PAGINA_PACS_GERENCIAR"]: {
        descricao: 'Gerenciar servidores STT e bridges PACS.',
        permissoes: [
            security_Permissao.PACS_EXAMES
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN
        ]
    },
    ["PAGINA_DICOM_HUB"]: {
        descricao: 'Acesso a página Dicom Hub.',
        permissoes: [
            security_Permissao.DICOM_HUB
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN
        ]
    },
    ["PAGINA_SERVIDOR_PACS"]: {
        descricao: 'Acesso à página Servidor PACS.',
        permissoes: [
            security_Permissao.DICOM_HUB
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["MINIPACS"]: {
        descricao: 'Operar um servidor minipacs pelo aplicativo.',
        permissoes: [
            security_Permissao.MINIPACS
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["PAGINA_VISUALIZADOR"]: {
        descricao: 'Acesso à aba Visualizador do módulo gestão PACS.',
        permissoes: [
            security_Permissao.PAGINA_VISUALIZADOR
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    },
    ["DICOM_HUB_APP"]: {
        descricao: 'Operar o Visualizador (stt-dicom-hub) instalado na estação.',
        permissoes: [
            security_Permissao.DICOM_HUB_APP
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN,
            security_TipoVinculo.INSTITUICAO
        ]
    }
};


;// CONCATENATED MODULE: ./src/security/TipoUsuario.ts
var TipoUsuario_TipoUsuario = /*#__PURE__*/ function(TipoUsuario) {
    TipoUsuario[TipoUsuario["ADMIN"] = 0] = "ADMIN";
    TipoUsuario[TipoUsuario["USUARIO_COM_VINCULO"] = 1] = "USUARIO_COM_VINCULO";
    TipoUsuario[TipoUsuario["USUARIO_SEM_VINCULO"] = 2] = "USUARIO_SEM_VINCULO";
    return TipoUsuario;
}(TipoUsuario_TipoUsuario || {});
/* export default */ const security_TipoUsuario = (TipoUsuario_TipoUsuario);

;// CONCATENATED MODULE: ./src/security/Rbac.ts



class Rbac {
    perfis;
    acesso;
    constructor(perfisRBAC){
        this.perfis = perfisRBAC;
    }
    montarAcesso(funcionalidade) {
        return this.montarAcessoPeloPerfis(funcionalidade);
    }
    temPermissao(funcionalidade) {
        const acesso = this.montarAcesso(funcionalidade);
        return acesso.temPermissao || false;
    }
    montarAcessoPeloPerfis(funcionalidade) {
        var _this_perfis, _this_perfis1, _this_perfis2, _this_perfis3, _this_perfis4;
        let acesso = {
            temPermissao: false,
            tipoUsuario: security_TipoUsuario.USUARIO_SEM_VINCULO,
            tipoVinculo: security_TipoVinculo.USUARIO,
            idsEstado: [],
            idsInstituicao: [],
            idsCidade: [],
            estados: [],
            idsRedeTeleconsultoria: []
        };
        // Caso a funcionalidade não exista. Retornar o acesso padrão.
        const funcionalidadeObj = FuncionalidadesMap[funcionalidade];
        if (!funcionalidadeObj) {
            return acesso;
        }
        // 1 - Verificar se é um perfil ADMIN, não precisa concatenar os vínculos, pois tem acesso a tudo. FIND
        const perfilAdm = (_this_perfis = this.perfis) === null || _this_perfis === void 0 ? void 0 : _this_perfis.find((e)=>{
            var // Verificar se é um perfil ADMIN
            _funcionalidadeObj_tipoVinculo, // Verificar se o tipo de vínculo do perfil está na funcionalidade
            _e_permissoes;
            return e.vinculo === 'G' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        });
        if (perfilAdm) return {
            ...acesso,
            temPermissao: true,
            tipoUsuario: security_TipoUsuario.ADMIN,
            tipoVinculo: security_TipoVinculo.ADMIN
        };
        // 2 - Perfis do tipo rede de teleconsultoria. Precisa concatenar os vínculos. FILTER.
        const perfisNivelRedeTeleconsultoria = ((_this_perfis1 = this.perfis) === null || _this_perfis1 === void 0 ? void 0 : _this_perfis1.filter((e)=>{
            var _funcionalidadeObj_tipoVinculo, _e_permissoes;
            return e.vinculo === 'D' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        })) || [];
        const arrayIdsRedeTeleconsultoria = perfisNivelRedeTeleconsultoria.map((perfil)=>perfil.redesTeleconsultoria.map((redeTeleconsultoria)=>redeTeleconsultoria.id));
        if (arrayIdsRedeTeleconsultoria.length > 0) {
            let idsRedeTeleconsultoria = arrayIdsRedeTeleconsultoria.reduce((a, acc)=>a.concat(acc));
            idsRedeTeleconsultoria = Array.from(new Set(idsRedeTeleconsultoria));
            acesso = {
                ...acesso,
                temPermissao: true,
                tipoUsuario: security_TipoUsuario.USUARIO_COM_VINCULO,
                tipoVinculo: security_TipoVinculo.REDE_TELECONSULTORIA,
                idsRedeTeleconsultoria
            };
            return acesso;
        }
        // 3 - Perfis do tipo estado. Precisa concatenar os vínculos. FILTER.
        const perfisNivelEstado = ((_this_perfis2 = this.perfis) === null || _this_perfis2 === void 0 ? void 0 : _this_perfis2.filter((e)=>{
            var _funcionalidadeObj_tipoVinculo, _e_permissoes;
            return e.vinculo === 'E' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        })) || [];
        const arrayIdsEstados = perfisNivelEstado.map((perfil)=>perfil.estados.map((estado)=>estado.id));
        const arrayEstados = perfisNivelEstado.map((perfil)=>perfil.estados.map((estado)=>estado.sigla));
        if (arrayIdsEstados.length > 0) {
            let idsEstado = arrayIdsEstados.reduce((a, acc)=>a.concat(acc));
            idsEstado = Array.from(new Set(idsEstado));
            let estados = arrayEstados.reduce((a, acc)=>a.concat(acc));
            estados = Array.from(new Set(estados));
            acesso = {
                ...acesso,
                temPermissao: true,
                tipoUsuario: security_TipoUsuario.USUARIO_COM_VINCULO,
                tipoVinculo: security_TipoVinculo.ESTADO,
                estados,
                idsEstado
            };
            return acesso;
        }
        // 4 - Perfis do tipo municipio. Precisa concatenar os vínculos. FILTER.
        const perfisNivelMunicipio = ((_this_perfis3 = this.perfis) === null || _this_perfis3 === void 0 ? void 0 : _this_perfis3.filter((e)=>{
            var _funcionalidadeObj_tipoVinculo, _e_permissoes;
            return e.vinculo === 'M' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        })) || [];
        const arrayIdsCidades = perfisNivelMunicipio.map((perfil)=>perfil.municipios.map((municipio)=>municipio.id));
        if (arrayIdsCidades.length > 0) {
            let idsCidade = arrayIdsCidades.reduce((a, acc)=>a.concat(acc));
            idsCidade = Array.from(new Set(idsCidade));
            acesso = {
                ...acesso,
                temPermissao: true,
                tipoUsuario: security_TipoUsuario.USUARIO_COM_VINCULO,
                tipoVinculo: security_TipoVinculo.MUNICIPIO,
                idsCidade
            };
            return acesso;
        }
        // 5 - Perfis do tipo instituição. Precisa concatenar os vínculos. FILTER.
        const perfisNivelInstituicoes = ((_this_perfis4 = this.perfis) === null || _this_perfis4 === void 0 ? void 0 : _this_perfis4.filter((e)=>{
            var _funcionalidadeObj_tipoVinculo, _e_permissoes;
            return e.vinculo === 'I' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        })) || [];
        const arrayIdsInstituicoes = perfisNivelInstituicoes.map((perfil)=>perfil.instituicoes.map((instituicao)=>instituicao.id));
        if (arrayIdsInstituicoes.length > 0) {
            let idsInstituicao = arrayIdsInstituicoes.reduce((a, acc)=>a.concat(acc));
            idsInstituicao = Array.from(new Set(idsInstituicao));
            acesso = {
                ...acesso,
                temPermissao: true,
                tipoUsuario: security_TipoUsuario.USUARIO_COM_VINCULO,
                tipoVinculo: security_TipoVinculo.INSTITUICAO,
                idsInstituicao
            };
            return acesso;
        }
        return acesso;
    }
}

;// CONCATENATED MODULE: ./src/dicom-hub/urlAcesso.ts
// Seam S1 do plano 03-ambientes-de-build-e-fonte-pacs-gerida (ADR-0013).
//
// A URL DICOMweb do dcm4chee é sempre da mesma forma:
//
//     http://150.162.6.8:30311/dcm4chee-arc / aets/PACS_UNAT/rs
//     └────────── url_base ───────────────┘   └── aets_path ──┘
//
// O `aets/` e o `/rs` são fixos do dcm4chee e nunca variam, mas até aqui o técnico
// os digitava. Um `aets/PACS_UNAT` sem o `/rs` não devolve erro de configuração —
// devolve zero exame, na estação, muito depois, sem mensagem nenhuma. Tirar as duas
// partes fixas do teclado elimina a classe inteira de erro.
//
// Mora em `packages/` porque é o MESMO cálculo no formulário (que mostra a prévia) e
// no modelo do backend (que serve o contrato antigo derivado). Duplicá-lo é
// exatamente como as duas metades divergiriam.
/** `aets/<AE>/rs`, com o AE Title capturado sem barras. */ const PADRAO_AETS_PATH = /^\/?aets\/([^/]+)\/rs\/?$/;
/**
 * Uma barra final, nunca duas, nunca nenhuma.
 *
 * A barra NÃO é cosmética. O cliente DICOMweb da estação monta a URL com
 * `new URL(prefixo, base)` — resolução relativa, não concatenação — e ali um
 * endereço sem barra final tem o último segmento tratado como arquivo e
 * DESCARTADO:
 *
 *     new URL('aets/PACS/rs', 'http://x:30311/dcm4chee-arc')
 *       -> http://x:30311/aets/PACS/rs          (sumiu o /dcm4chee-arc)
 *     new URL('studies/1.2.3', 'http://x/dcm4chee-arc/aets/PACS/rs')
 *       -> http://x/dcm4chee-arc/aets/PACS/studies/1.2.3   (sumiu o /rs)
 *
 * O PACS responde 404, a estação mostra zero exame, e nada na tela diz por quê —
 * exatamente a falha que o ADR-0013 existe para eliminar, reaparecendo do lado
 * de dentro. Verificado contra `dicom-source/dicomweb/index.ts` do stt-dicom-hub.
 */ function umaBarraFinal(valor) {
    const limpo = (valor ?? '').trim().replace(/\/+$/, '');
    return limpo === '' ? '' : `${limpo}/`;
}
/**
 * Compõe o contrato antigo a partir da verdade nova.
 *
 * Normaliza os dois lados para EXATAMENTE uma barra final: nem `//aets/`, que
 * alguns proxies tratam diferente, nem barra faltando, que faz o `new URL` da
 * estação comer um segmento (ver `umaBarraFinal`). É a única regra do sistema que
 * decide isso — espalhá-la pela interface é como o erro voltaria a se esconder.
 */ function composicaoUrlAcesso(urlBase, aeTitle) {
    return {
        urlAcesso: umaBarraFinal(urlBase),
        aetsPath: `aets/${(aeTitle ?? '').trim()}/rs/`
    };
}
/**
 * O inverso, para ler configuração gravada antes do ADR-0013.
 *
 * Devolve `null` quando o `aetsPath` não casa `aets/<AE>/rs` — **nunca um palpite**.
 * Chutar aqui reproduziria em massa a falha silenciosa que este seam existe para
 * eliminar: o técnico veria um AE Title plausível num formulário que parece
 * carregado, e o primeiro "Salvar" sobrescreveria uma configuração que funcionava.
 */ function decomporUrlAcesso(urlAcesso, aetsPath) {
    const casou = PADRAO_AETS_PATH.exec((aetsPath ?? '').trim());
    if (!casou) return null;
    return {
        urlBase: umaBarraFinal(urlAcesso),
        aeTitle: casou[1]
    };
}

;// CONCATENATED MODULE: ./src/notificacoes/tiposComando.ts
const TIPOS_COMANDO_INSTITUICAO = [
    'agendado',
    'invalidacao',
    'restaurar'
];
const ehTipoComandoInstituicao = (tipo)=>TIPOS_COMANDO_INSTITUICAO.includes(String(tipo ?? '').toLowerCase());

;// CONCATENATED MODULE: ./index.ts
// Export all security-related modules





// URL de acesso do Visualizador: composição e decomposição (ADR-0013). Consumido
// pelo modelo do backend e pelo formulário do frontend — um cálculo só.



var __webpack_exports__Funcionalidade = __webpack_exports__.DL;
var __webpack_exports__FuncionalidadesMap = __webpack_exports__.mI;
var __webpack_exports__Permissao = __webpack_exports__.Ud;
var __webpack_exports__Rbac = __webpack_exports__.l6;
var __webpack_exports__TIPOS_COMANDO_INSTITUICAO = __webpack_exports__.pJ;
var __webpack_exports__TipoUsuario = __webpack_exports__.Ru;
var __webpack_exports__TipoVinculo = __webpack_exports__.b5;
var __webpack_exports__composicaoUrlAcesso = __webpack_exports__.Xk;
var __webpack_exports__decomporUrlAcesso = __webpack_exports__.bI;
var __webpack_exports__ehTipoComandoInstituicao = __webpack_exports__.$e;
export { __webpack_exports__Funcionalidade as Funcionalidade, __webpack_exports__FuncionalidadesMap as FuncionalidadesMap, __webpack_exports__Permissao as Permissao, __webpack_exports__Rbac as Rbac, __webpack_exports__TIPOS_COMANDO_INSTITUICAO as TIPOS_COMANDO_INSTITUICAO, __webpack_exports__TipoUsuario as TipoUsuario, __webpack_exports__TipoVinculo as TipoVinculo, __webpack_exports__composicaoUrlAcesso as composicaoUrlAcesso, __webpack_exports__decomporUrlAcesso as decomporUrlAcesso, __webpack_exports__ehTipoComandoInstituicao as ehTipoComandoInstituicao };
